import { NO_USER_PROFILE_TYPE } from 'src/constants/profile'

export const ANONYMOUS_USER_TYPE = NO_USER_PROFILE_TYPE
export const ANONYMOUS_PROFILE_ID = ANONYMOUS_USER_TYPE
export const NO_PROFILE = 'noUserProfile'
export const INTERMEDIATE_PROFILE = 'IntermediateProfile'
export const FULL_PROFILE = 'FullProfile'
export const PROFILE_STEP_PROFILE_COMPLETE = 'completeProfile'
export const PROFILE_STEP_EMAIL_CONFIRMED = 'confirmedProfile'
export const PROFILE_STEP_VERIFIED = 'verifiedProfile'
export const IDENTITY_PROVIDER_APPLE = 'apple'
export const IDENTITY_PROVIDER_FACEBOOK = 'facebook'
export type IdentityProviderType = typeof IDENTITY_PROVIDER_APPLE
  | typeof IDENTITY_PROVIDER_FACEBOOK;
